import { reactive, ref, computed } from '@vue/composition-api'
import * as apiMyLink from '@/api/my-link'

/**
 * マイリンク並び替え
 */
export const getGroup = (props, context) => {
  
  const group1 = reactive({

    id: 0, // 操作対象のID
    list: [], // マイリンク一覧

    /**
     * 初期表示
     */
    init: () => {

      // 親ウィンドウの一覧を保持する
      group1.id = props.myLinkParams.id
      group1.list = props.myLinkParams.list
    },

    /**
     * 対象マイリンクを最上位に移動
     */
    moveMyLinkToTop: () => {

      const newList = []
      for (let i = 0; i < group1.list.length; i++) {
        if (group1.list[i].id === group1.id) {
          newList.unshift(group1.list[i])
        } else {
          newList.push(group1.list[i])
        }
      }
      group1.list = newList

      // マイリンク一括更新
      group1.updateMyLinkInBulk() 
    },

    /**
     * 対象マイリンクを一つ上に移動
     */
    moveMyLinkUpOne: () => {

      const newList = []
      for (let i = 0; i < group1.list.length; i++) {
        if (group1.list[i].id === group1.id) {
          const last = newList.pop()
          newList.push(group1.list[i])
          if (typeof last !== 'undefined') {
            newList.push(last)
          }
        } else {
          newList.push(group1.list[i])
        }
      }
      group1.list = newList

      // マイリンク一括更新
      group1.updateMyLinkInBulk() 
    },

    /**
     * 対象マイリンクを一つ下に移動
     */
    moveMyLinkDownOne: () => {

      const newList = []
      for (let i = group1.list.length - 1; i >= 0; i--) {
        if (group1.list[i].id === group1.id) {
          const last = newList.pop()
          newList.push(group1.list[i])
          if (typeof last !== 'undefined') {
            newList.push(last)
          }
        } else {
          newList.push(group1.list[i])
        }
      }
      group1.list = newList.reverse()

      // マイリンク一括更新
      group1.updateMyLinkInBulk() 
    },

    /**
     * 対象マイリンクを最下位に移動
     */
    moveMyLinkToBottom: () => {

      const newList = []
      for (let i = group1.list.length - 1; i >= 0; i--) {
        if (group1.list[i].id === group1.id) {
          newList.unshift(group1.list[i])
        } else {
          newList.push(group1.list[i])
        }
      }
      group1.list = newList.reverse()

      // マイリンク一括更新
      group1.updateMyLinkInBulk() 
    },

    /**
     * マイリンク一括更新
     */
    updateMyLinkInBulk: () => {

      // リクエストパラメータとして送信する項目に整形
      const listWork = []
      for (let i = 0; i < group1.list.length; i++) {
        const map = {
          title: group1.list[i].title,
          url: group1.list[i].url,
          new_window: group1.list[i].new_window
        }
        listWork.push(map)
      }

      // マイリンク一括更新APIをコール
      const params = {}
      params.json = JSON.stringify(listWork)

      apiMyLink.updateInBulk(params)
        .then(response => {
          if (response) {
            const { data } = response

            // 親ウィンドウのマイリンク一覧をリロード
            context.emit('loadMyLink')

            // ウィンドウを閉じる
            context.emit('closeMyLinkChangePosition')
          }
        })
    }

  })

  return group1
}
